<span class="total">{{ total || '0' }}</span>
<span class="delimiter">/</span>
<span class="target">{{ target || 'N/A' }}</span>
